import { render } from "./DashboardContractModelRender.vue?vue&type=template&id=55c3c0b1"
import script from "./DashboardContractModelRender.vue?vue&type=script&lang=js"
export * from "./DashboardContractModelRender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__